import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { NoProfile } from '../assets';
import moment from 'moment';
import { GoCommentDiscussion, GoShareAndroid } from 'react-icons/go';
import { MdCancelPresentation, MdOutlineDeleteOutline } from 'react-icons/md';

import { BiLike, BiSolidLike } from 'react-icons/bi';
import { get, useForm } from 'react-hook-form';
import { CustomButton, Loading, TextInput } from '../components';

import { BsDot } from 'react-icons/bs';
import { RxDotFilled } from 'react-icons/rx';
import { apiRequest, getUserInfo } from '../utils';

import { HiDotsVertical } from 'react-icons/hi';
import PostMenuOption from './PostMenuOption.jsx';
import PostDetail from './post/PostDetail.jsx';
import { useSelector } from 'react-redux';
import { useModal } from '../context/ModalContext.jsx';
import { FaHeart, FaRegHeart } from 'react-icons/fa';

const getPostComments = async (id) => {
  try {
    const res = await apiRequest({
      url: "/posts/comments/" + id,
      method: "GET",
    });
    return res?.data;
  } catch (error) {
    console.log(error);
  }
}

// Comment form
const CommentForm = ({ user, id, replyAt, getComments }) => {
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors } } = useForm({
      mode: "onChange"
    });

  const onSubmit = async (data) => {
    // console.log(id)
    setLoading(true);
    setErrMsg("");
    try {
      const URL = !replyAt
        ? "/posts/comment/" + id
        : "/posts/reply-comment/" + id;

      const newData = {
        comment: data?.comment,
        from: user?.firstName + " " + user?.lastName,
        replyAt: replyAt,
      };

      const res = await apiRequest({
        url: URL,
        data: newData,
        token: user?.token,
        method: "POST",
      });

      if (res?.status === "failed") {
        setErrMsg(res);
      } else {
        reset({
          comment: "",
        });
        setErrMsg("");
        await getComments();
      };
      setLoading(false);

    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <form
      className='w-full border-[#66666645]'
      onSubmit={handleSubmit(onSubmit)}>
      <div className='w-full flex items-center gap-2 py-4'>
        <img
          src={user?.profileUrl ?? NoProfile}
          alt="User Image"
          className='w-8 h-8 rounded-full object-cover'
        />
        <TextInput
          name="comment"
          styles="w-full rounded-full py-3"
          placeholder={replyAt ? `Reply @${replyAt}` : "Write a comment..."}
          register={register("comment", {
            required: "Comment can not be empty",
          })}
          error={errors.comment ? errors.comment.message : ""}
        >
        </TextInput>
        <div className='flex items-center '>
          {loading ? (
            <Loading />
          ) : (
            <CustomButton
              title="Submit"
              type="submit"
              containerStyles='bg-[#0444a4] text-white py-1 px-3 rounded-full font-semibold text-sm'>
              {/* <FaCircleArrowUp className='cursor-pointer' size={28} color="#0766FF" /> */}
            </CustomButton>
          )}
        </div>
      </div>

      {errMsg?.message && (
        <span
          role='alert'
          className={`text-sm ${errMsg?.status === "failed"
            ? "text-[#f64949fe]"
            : "text-[#2ba150fe]"
            } mt-0.5`}
        >
          {errMsg?.message}
        </span>
      )}
    </form>
  )
};

// Reply card
const ReplyCard = ({ reply, user, handleLike }) => {
  return (
    <div className='w-full py-3'>
      <div className='flex gap-3 items-center mb-1'>
        <Link to={"/profile/" + reply?.userId?._id}>
          <img
            src={reply?.userId?.profileUrl ?? NoProfile}
            alt={reply?.userId?.firstName}
            className='w-8 h-8 rounded-full object-cover'
          />
        </Link>

        <div className='flex items-center'>
          <Link to={"/profile/" + reply?.userId?._id}>
            <p className='font-medium text-base text-ascent-1'>
              {reply?.userId?.firstName} {reply?.userId?.lastName}
            </p>
          </Link>
          <span>
            <RxDotFilled />
          </span>
          <span className='text-ascent-2 text-sm'>
            {moment(reply?.createdAt).fromNow()}
          </span>
        </div>
      </div>

      <div className='ml-12'>
        <p className='text-ascent-2'>{reply?.comment}</p>
        <div className='mt-2 flex gap-6'>
          <p
            className='flex gap-2 items-center text-base text-ascent-2 cursor-pointer'
            onClick={handleLike}
          >
            {reply?.likes?.includes(user?._id) ? (
              <BiSolidLike size={20} color="blue"></BiSolidLike>
            ) : (
              <BiLike size={20}></BiLike>
            )}
            {reply?.likes?.length} Likes
          </p>
        </div>
      </div>
    </div>
  )
}

const PostMenu = ({ userId, postUserId, showPostOption, setShowPostOption }) => {
  // console.log(postUserId)
  return (
    <>
      <span
        className="relative cursor-pointer"
        onClick={() => setShowPostOption(!showPostOption)}
      >
        <HiDotsVertical />
        {showPostOption && (
          <PostMenuOption userId={userId} postUserId={postUserId} />
        )}
      </span>
    </>
  )
}

// ----------<  Post Container  >----------
const PostCard = ({ post, user, deletePost, likePost }) => {
  const [showAll, setShowAll] = useState(0);
  const [showReply, setShowReply] = useState(0);
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [replyComments, setReplyComments] = useState(0);
  const [showComments, setShowComments] = useState(0);
  const [showPostOption, setShowPostOption] = useState(false);
  const menuRef = useRef();

  const navigate = useNavigate();

  const { isOpen, selectedPost, openModal, closeModal } = useModal();

  useEffect(() => {
    let handler = (e) => {
      if (!menuRef.current.contains(e.target)) {
        setShowPostOption(false);
        // console.log(menuRef.current);
      }
    }
    document.addEventListener('mousedown', handler);
    return () => {
      document.removeEventListener('mousedown', handler);
    }
  }, [])

  const getComments = async (id) => {
    setReplyComments(0);
    const result = await getPostComments(id);
    setComments(result);
    setLoading(false);
  }

  const handleLike = async (uri) => {
    await likePost(uri);
    await getComments(post?._id);
  }

  // handle modal state


  return (
    // --------< Edit Profile >--------
    <>
      <div className='mb-2 bg-primary px-6 py-5 shadown-sm border-b border-[#cccccc] rounded-lg'>
        <div className="flex gap-3 items-center mb-2">
          <Link to={"/profile/" + post?.userId?._id} className='w-12 h-full object-cover rounded-full'>
            <img
              src={post?.userId?.profileUrl ?? NoProfile}
              alt={post?.userId?.firstName}
              className='object-cover rounded-full'
            />
          </Link>

          <div className='w-full flex justify-between'>
            <div className=''>
              <Link to={"/profile/" + post?.userId?._id}>
                <p className="font-medium text-15px text-ascent-1">
                  {post?.userId?.firstName} {post?.userId?.lastName}
                </p>
              </Link>
              <div className='flex items-center'>
                <span className='text-[#65676B] text-14px font-semibold'>{post?.userId?.location}</span>
                <div
                  onClick={() => { }}
                >
                  <BsDot />
                </div>
                <span className="text-14px">
                  {moment(post?.createdAt ?? "2024-8-31").fromNow()}
                </span>
              </div>

            </div>

            {/* post option */}
            <div
              ref={menuRef}>
              <PostMenu postUserId={post?.userId?._id} userId={user?._id} showPostOption={showPostOption} setShowPostOption={setShowPostOption} />

            </div>

          </div>
        </div>

        <div>
          {/* Content */}
          <p className="text-ascent-1 text-sm">
            {showAll === post?._id
              ? post?.description
              : post?.description.slice(0, 300)}

            {post?.description?.length > 301 &&
              (showAll === post?._id
                ? (
                  <span
                    className='text-blue ml-2 font-medium cursor-pointer'
                    onClick={() => setShowAll(0)}>Show less</span>
                )
                : (<span
                  className='text-blue ml-2 font-medium cursor-pointer'
                  onClick={() => setShowAll(post?._id)}>See more</span>)
              )}
          </p>

          {/* Post images */}
          {post?.image && (
            <div className='w-full'>
              <img
                src={post?.image}
                alt="post image"
                className="w-1/2 mt-2 mx-auto rounded-lg cursor-pointer"
                onClick={() => openModal(post)}
              />
            </div>
          )}
        </div>

        <div className='mt-4 px-3 py-4 text-ascent-2 text-base border-[#66666645]'>
          {/* Reaction Overview */}
          <div className=''>
            {/* <p className='flex gap-1 items-center text-base cursor-pointer'>
            {post?.likes?.includes(user?._id) ? (
              <div className='flex items-center'>
                <BiSolidLike size={20} color="#0766FF" className='' />
                <FcLike size={20} />
                <span>You and</span>
              </div>
            ) : (
              <BiLike size={20} />
            )}
            {post?.likes.length}
            {post?.likes?.includes(user?._id)
              ? (<span>others</span>)
              : (<span>likes</span>)
            }
          </p> */}

            <p className='flex gap-2 items-center text-base cursor-pointer'

            ></p>

          </div>

          {/* Action */}
          <div className='mt-4 flex justify-between items-center px-3 py-2 text-ascent-2 text-base border-b border-[#66666645]'>
            {/* handle like post */}
            <div
              className='flex gap-2 items-center cursor-pointer'
              onClick={() => handleLike("/posts/like/" + post?._id)}>
              {post?.likes?.includes(user?._id) ? (
                <FaHeart size={20} color='red' />
              ) : (
                <FaRegHeart size={20} />
              )}
              {post?.likes?.length} Likes

            </div>

            <p
              className='flex gap-2 items-center text-base cursor-pointer'
              onClick={() => {
                setShowComments(showComments === post._id ? null : post._id);
                getComments(post?._id);
              }}>
              <GoCommentDiscussion size={20} />
              {post?.comments?.length} comments
            </p>

            <p className='flex gap-2 items-center text-base cursor-pointer'>
              <GoShareAndroid />
              <span>Share</span>
            </p>

            {/* {user?._id === post?.userId?._id && (
              <div
                className='flex items-center cursor-pointer'
                onClick={() => deletePost(post?._id)}
              >
                <MdOutlineDeleteOutline size={20} />
                <span>Delete</span>
              </div>
            )} */}
            
          </div>
        </div>

        {/* Comment Section */}
        {
          showComments === post?._id && (
            <div className='w-full border-[#66666645]'>
              <CommentForm
                user={user}
                id={post?._id}
                getComments={() => getComments(post?._id)}
              />

              {loading ?
                (<Loading />) : comments?.length > 0 ? (
                  comments?.map((comment) => (
                    //  Comment Container
                    <div className='w-full flex pt-2 pb-4' key={comment?._id}>

                      <div className="user-avatar">
                        <Link to={"/profile/" + comment?.userId?._id}>
                          <img
                            src={comment?.userId?.profileUrl ?? NoProfile}
                            alt={comment?.userId?.firstName}
                            className="h-10 w-10 rounded-full object-cover"
                          />
                        </Link>
                      </div>

                      <div className="user-comment-content ml-6">
                        <div className='flex gap-3 items-center mb-1'>
                          <div className='flex items-center'>
                            <Link to={"/profile/" + comment?.userId?._id}>
                              <p className='font-medium text-base text-ascent'>
                                {comment?.userId?.firstName} {comment?.userId?.lastName}
                              </p>
                            </Link>
                            <span>
                              <RxDotFilled />
                            </span>
                            <span className='text-ascent-2 text-sm'>
                              {moment(comment?.createdAt ?? "2024-9-01").fromNow()}
                            </span>
                          </div>
                        </div>

                        <div className=''>
                          <p className='text-ascent-2'>{comment?.comment}</p>

                          <div className='flex mt-2 gap-6'>
                            <p
                              className='flex gap-2 items-center text-base text-ascent-2 cursor-pointer'
                              onClick={() => {
                                handleLike("/posts/like-comment/" + comment?._id);
                              }}
                            >
                              {comment?.likes?.includes(user?._id) ? (
                                <BiSolidLike size={20} color="blue"></BiSolidLike>
                              ) : (<BiSolidLike size={20}></BiSolidLike>)}
                              {comments?.likes?.length} Like
                            </p>
                            <span
                              className='text-blue cursor-pointer'
                              onClick={() => setReplyComments(comment?._id)}>
                              Reply
                            </span>
                          </div>

                          {replyComments === comment?._id && (
                            <CommentForm
                              user={user}
                              id={comment?._id}
                              replyAt={comment?.from}
                              getComments={() => getComments(post?._id)}
                            />
                          )}

                        </div>

                        {/* Reply comments - Show more comments*/}
                        <div>
                          {comment?.replies.length > 0 && (
                            <p
                              className='text-base text-ascent-2 cursor-pointer mt-4'
                              onClick={() => {
                                setShowReply(
                                  showReply === comment?.replies?._id
                                    ? 0
                                    : comment?.replies?._id
                                )
                              }}
                            >
                              View more comments
                            </p>
                          )}

                          {showReply === comment?.replies?._id && (
                            comment?.replies?.map((reply) => (
                              <ReplyCard
                                reply={reply}
                                user={user}
                                key={reply?._id}
                                handleLike={() =>
                                  "/posts/like-comment/"
                                  + comment?._id
                                  + "/"
                                  + reply?._id
                                }
                              ></ReplyCard>
                            ))
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <span className='flex text-sm py-4 text-ascent-2 text-center'>
                    No comments yet. Be the first to comment.
                  </span>
                )}
            </div>

          )}
      </div>
    </>

  )
}

export default PostCard